import { CONTACT } from "@/data/content";
import { scrollToId, openInquiry } from "@/lib/scroll";

const Footer = () => (
  <footer className="bg-[#1A362B] text-[#F5F2EB] pt-20 md:pt-28 pb-10 overflow-hidden" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-10 pb-16 border-b border-[#F5F2EB]/15">
        <div>
          <p className="uppercase text-[10px] tracking-[0.3em] font-semibold text-[#F5F2EB]/50 mb-4">
            TrekPanda · Pune, India
          </p>
          <div className="space-y-2 text-sm font-light text-[#F5F2EB]/80">
            <a href={CONTACT.phoneHref} className="block hover:text-[#B7E4BD] transition-colors duration-300" data-testid="footer-phone-link">
              {CONTACT.phoneDisplay}
            </a>
            <a href={`mailto:${CONTACT.email}`} className="block hover:text-[#B7E4BD] transition-colors duration-300" data-testid="footer-email-link">
              {CONTACT.email}
            </a>
            <a
              href={CONTACT.website}
              target="_blank"
              rel="noopener noreferrer"
              className="block hover:text-[#B7E4BD] transition-colors duration-300"
              data-testid="footer-website-link"
            >
              trekpanda.in
            </a>
            <p className="pt-4 text-xs leading-relaxed text-[#F5F2EB]/55" data-testid="footer-address">
              TrekPanda India LLP, 4th Floor Sadanand Apartment,<br />
              Opp. Bhabha Hospital, Shivaji Nagar,<br />
              Pune, Maharashtra 411007
            </p>
          </div>
        </div>
        <button
          onClick={openInquiry}
          className="self-start md:self-auto bg-[#F5F2EB] text-[#1A362B] text-xs font-semibold uppercase tracking-[0.2em] px-8 py-4 hover:bg-[#B7E4BD] transition-colors duration-300"
          data-testid="footer-cta-button"
        >
          Plan my Bhutan trip
        </button>
      </div>

      <div className="py-14 md:py-20 select-none" aria-hidden="true">
        <h2 className="font-heading font-light text-[17.5vw] leading-[0.85] tracking-tight text-[#F5F2EB]/12 text-center whitespace-nowrap">
          TrekPanda
        </h2>
      </div>

      <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-8 border-t border-[#F5F2EB]/15 text-[11px] uppercase tracking-[0.2em] text-[#F5F2EB]/45">
        <span className="flex items-center gap-2">
          <img src="/trekpanda-mark.png" alt="TrekPanda" className="h-9 w-auto" />
        </span>
        <span data-testid="footer-copyright">© 2026 TrekPanda. Wander responsibly.</span>
      </div>
    </div>
  </footer>
);

export default Footer;
